/* eslint-disable camelcase */
export default {
    AMIG_CAT_BroteBacken: 'brot_backen',
    AMIG_CAT_ChipsSnacksAperos: 'chips_snacks_apero',
    AMIG_CAT_FleischFisch: 'fleisch_fisch',
    AMIG_CAT_FruechteGemuese: 'fruechte_gemuese',
    AMIG_CAT_Getraenke: 'getreanke',
    AMIG_CAT_Grundnahrungsmittel: 'grundnahrungsmittel_lebensmittel',
    AMIG_CAT_HaushaltReinigung: 'haushalt_reinigung',
    AMIG_CAT_HygieneGesundheitBaby: 'hygiene_gesundheit_baby',
    AMIG_CAT_MilchprodukteEier: 'milchprodukte',
    AMIG_CAT_MueesliCerealienBrotaufstriche: 'muesli_cerealien_brotaufstriche',
    AMIG_CAT_SchokoladenSuessigkeiten: 'schokolade_suessigkeiten',
    AMIG_DISCOUNTS: 'sale',
    default: 'fruechte_gemuese',
};
/* eslint-enable camelcase */



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/category-icons.js